import { inject, type InjectionKey, type ComputedRef } from 'virtual-vue';
import type { StepDirection } from './step';

/**
 * 步骤项索引管理器
 * 用于管理步骤项的索引
 */
export class StepItemIndex {
  private stepKeys: symbol[] = [];
  /**
   * 获取步骤项索引
   * @param key 步骤项唯一标识
   * @returns
   */
  getItemIndex(key: symbol) {
    if (!key) {
      throw new Error('StepItem key is required');
    }
    if (!this.stepKeys.includes(key)) {
      this.stepKeys.push(key);
    }
    return this.stepKeys.indexOf(key);
  }
  /**
   * 清除步骤项Key
   * @param key 步骤项标识
   */
  clearItem(key: symbol) {
    if (key && this.stepKeys.includes(key)) {
      this.stepKeys.splice(this.stepKeys.indexOf(key), 1);
    }
  }
}

export interface StepProvide {
  /** 步骤条方向 */
  direction: ComputedRef<StepDirection>;
  /** 当前激活步骤索引 */
  active: ComputedRef<number>;
  /** 流程是否连贯 */
  flow: ComputedRef<boolean>;
  /** 步骤项索引管理 */
  indexMgr: StepItemIndex;
}

export const STEP_INJECT_KEY = Symbol('STEP') as InjectionKey<StepProvide>;

/**
 * 获取 Step 的 provide
 */
export function useStepInject() {
  const step = inject(STEP_INJECT_KEY) as StepProvide;
  return step;
}
